<template>
  <div>
    <div class="choice-header">
      <div class="button-choice">
        <span class="font-weight-bolder mr-2">ตัวเลือก</span>
        <span
          v-if="choices.length < 2"
          class="no-answer"
        >ไม่มีตัวเลือก</span>
      </div>
    </div>

    <draggable
      :list="choices"
      disabled="disableDrag"
    >
      <div
        v-for="(choice, choiceIndex) in choices"
        :key="choiceIndex"
        class="choice-list"
        :class="isSelected(choice.id) ? 'choice-list-selected' : 'choice-list'"
        style="padding-left: 25px;"
      >
        <div class="choice-text">
          <div class="choice-text-info py-1">
            <span class="font-weight-bolder mr-4 mb-0">{{ choiceIndex + 1 }}</span>
            <mark-down class="mr-2 mb-0 exam-choice" :message="choice.text"></mark-down>
          </div>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import draggable from "csq-vue-multi-draggable";
import MarkDown from "@/components/shared/Markdown.vue";

export default {
  props: {
    question: Object,
    choices: Array,
    isSubQuestion: {
      type: Boolean,
      default: false,
    },
    mainQuestionId: {
      type: String,
      default: "",
    },
  },
  components: {
    draggable,
    MarkDown
  },
  data() {
    return {
      token: localStorage.getItem("token"),
      ModalShowChoice: false,
      disableDrag: false,
      disableCreateChoice: false,
      isShowedExample: false, 
      
      markdown: "markdown",
      
      selectedChoices: [],

      tempChoiceText: "",
      tempChoiceIndex: "",
      tempChoiceId: "",
      answer: []
    };
  },
  async created() {
    this.disableDrag = true;
    await this.getAnswerChecked();
    this.disableDrag = false;
  },
  computed: {
    ...mapGetters("ExamBuilder", [
      //entire exam
      "exam",

      // temp answer from endpoint get answer
      "allAnswer",

      // temp choice from creating choice
      "tempChoice",

      // objecct of hasAnswer
      "hasAnswers",
    ]),
  },
  methods: {
    ...mapActions("ExamBuilder", [

      // Answer
      "fetchQuestionAnswer",

      //set solution
      "setNoSolution"
    ]),
    // get answer
    async getAnswerChecked() {
      try {
        // Check if this question has an answer
        if (!this.hasAnswers[this.question.id]) {
          this.setNoSolution(this.question.id)
          return;
        }

        // Fetch the answer based on whether it's a sub-question or not
        await this.setQuestionAnswer();

      } catch (error) {
        console.log(error);
      }
    },

    async setQuestionAnswer() {
      this.answer = Array.isArray(this.allAnswer)
        ? this.allAnswer.find(item => item && item.questionId === this.question.id)
        : null;
      this.selectedChoices = [...this.answer.choiceId];
    },

    isSelected(id) {
      return this.selectedChoices.includes(id);
    },

    hideModal() {
      this.$refs["modal-editor"].hide();
    },
  },
};
</script>

<style lang="css">
.exam-choice img{
  max-width: 30%;
  word-break: break-word;
}
</style>

<style lang="css" scope>
.no-answer {
    color: orange;
    width: 100%;
    padding: 10px;
    background-color: #f9e7d5;
    border: #f9e7d5 1px solid;
    border-radius: 5px;
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.handle {
  cursor: move;
}
.choice-header {
  display: flex;
  justify-content: space-between;
}
.show-choice-text {
  max-width: 50vw;
}
.choice-button-group {
  display: flex;
  justify-content: center;
}

.choice-button-group .btn {
  padding: 1px 6px !important;
}

.choice-button .choice-button-icon {
  width: 16px;
  display: flex;
  justify-content: center;
}

.add-choice {
  cursor: pointer;
}

.button-choice {
  display: flex;
  justify-content: space-between;
}

.example-container {
  margin-left: 4% !important;
}

.example-container img {
  height: 75px;
}

.example-text {
  display: flex;
  justify-content: baseline;
}

.disabled-link {
  pointer-events: none;
  opacity: 0.6;
}
</style>
